import React, { useState } from 'react';
import { processSteps } from '../mock';

const Process = () => {
  const [active, setActive] = useState(0);
  const step = processSteps[active];

  return (
    <section className="bg-[#0a0a0a] py-28 lg:py-40 px-6 lg:px-12">
      <div className="max-w-[1500px] mx-auto">
        <div className="text-center mb-20">
          <p className="text-[#c9a96e] text-[11px] tracking-[0.5em] uppercase mb-6">The Experience</p>
          <h2 className="font-serif text-white text-5xl md:text-6xl lg:text-7xl leading-[1.05]">How We Work</h2>
          <h2
            className="font-serif italic text-[#c9a96e] text-5xl md:text-6xl lg:text-7xl leading-[1.05] -mt-1"
            style={{ fontFamily: 'Cormorant Garamond, serif' }}
          >
            Together
          </h2>
          <p className="text-white/60 mt-8 max-w-xl mx-auto leading-relaxed">
            A refined five-step journey from initial vision to flawless execution — the same meticulous process applied to every event we have the honour of producing.
          </p>
        </div>

        {/* Step tabs */}
        <div className="relative">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 border-t border-white/10">
            {processSteps.map((s, i) => {
              const isActive = i === active;
              return (
                <button
                  key={s.number}
                  onClick={() => setActive(i)}
                  className={`relative text-left py-8 px-5 border-b transition-colors duration-300 ${
                    isActive
                      ? 'bg-white/[0.03] border-b-transparent'
                      : 'border-b-white/10 hover:bg-white/[0.02]'
                  }`}
                >
                  {isActive && (
                    <span className="absolute top-0 left-0 right-0 h-px bg-[#c9a96e]" />
                  )}
                  <div
                    className={`font-serif text-2xl mb-3 transition-colors ${
                      isActive ? 'text-[#c9a96e]' : 'text-white/30'
                    }`}
                  >
                    {s.number}
                  </div>
                  <div
                    className={`text-[10px] tracking-[0.35em] uppercase mb-3 transition-colors ${
                      isActive ? 'text-[#c9a96e]' : 'text-white/40'
                    }`}
                  >
                    {s.label}
                  </div>
                  <div
                    className={`font-serif text-base md:text-lg leading-snug transition-colors ${
                      isActive ? 'text-white' : 'text-white/60'
                    }`}
                    style={{ fontFamily: 'Cormorant Garamond, serif' }}
                  >
                    {s.title}
                  </div>
                </button>
              );
            })}
          </div>

          {/* Active content */}
          <div className="relative border border-white/10 border-t-0 p-8 md:p-14 lg:p-20 min-h-[280px]">
            <h3 className="font-serif text-white text-3xl md:text-4xl lg:text-5xl max-w-3xl">
              {step.title}
            </h3>
            <p className="mt-8 max-w-3xl text-white/70 text-[15px] leading-[1.9] font-light">
              {step.description}
            </p>
            <div
              className="absolute right-8 lg:right-14 bottom-8 lg:bottom-14 font-serif text-[#c9a96e]/30 text-7xl md:text-8xl"
              style={{ writingMode: 'vertical-rl' }}
            >
              Step {step.number}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
